<pr-form
  (onSubmit)="onSubmit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <h3>Paramètres de l'investissement</h3>

  @if (options && options.sessionConsultant) {
    <pr-input label="Contrat" [derrors]="derrors">
      <pr-select-search
        formControlName="productId"
        [options]="$packs | async"
        optionValueKey="id"
        optionDisplayKey="name"
        placeholder="Rechercher un contrat..."
      ></pr-select-search>
    </pr-input>
  }

  <pr-input label="Versement initial" suffix="€" [derrors]="derrors">
    <input formControlName="initialDeposit" type="text" />
  </pr-input>

  <pr-input label="Versements réguliers" suffix="€ / mois" [derrors]="derrors">
    <input formControlName="monthlyDeposit" type="text" />
  </pr-input>
  <pr-input label="Durée de l'investissement" suffix="ans" [derrors]="derrors">
    <input formControlName="durationInYears" type="text" />
  </pr-input>
  @if (options && options.sessionConsultant) {
    <pr-input label="Frais d'entrée" suffix="%" [derrors]="derrors">
      <input formControlName="entryFee" type="text" />
    </pr-input>
  }
</pr-form>
